<script lang="ts">
  import {onMount} from 'svelte/internal';
  import type {GridConfig, PreviewImage} from '@/types/common';
  import type {Shapes} from '@/types/filters';
  import editorInstance from '@/lib/editor/editor';
  import ImageService from '@/services/image';
  import viddialogStore from '@/pages/thumbPreview/viddialog-store';

  export const title = 'Templates';

  const shapes = ['Square', 'Vertical', 'Horizontal'];

  const isAdmin = window.uData && window.uData.is_admin;
  let gridProps: GridConfig = {
    images: [],
    loading: true,
    columnCount: 4
  };

  let page: number = 1;
  let limit: number = 10;
  let selectedTags: string = '';
  let selectedShape: Shapes = '';
  let favorites: boolean = false;
  let loadMore: Boolean = false;
  let fullSidebar: boolean = false;
  let fullHeight: boolean = false;

  const imageService = new ImageService();
  onMount(async () => {
    imageService.getImageList(page, limit).then(images => {
      // console.log(images);
      gridProps = {
        ...gridProps,
        loading: false,
        images: images?.items.map((image: any) => {
          return {
            id: image.id,
            src: image.url,
            title: image.name,
            content: image.url
          };
        })
      };
    });
  });

  const insertSnapshot = async (image: PreviewImage) => {
    editorInstance.insertPastorPic(image.src);
  };

  const appendImages = async () => {
    if (page != 1) {
      imageService.getImageList(page, limit).then(images => {
        gridProps = {
          ...gridProps,
          images: [
            ...gridProps.images,
            ...images?.items.map((image: any) => {
              return {
                id: image.id,
                src: image.url,
                title: image.name,
                content: image.url
              };
            })
          ]
        };
      });
    }
  };

  const checkScrollEvent = (e: Event) => {
    const target = e.target as Element;
    const {scrollHeight, scrollTop, clientHeight} = target;

    loadMore = Math.abs(scrollHeight - scrollTop - 2) <= Math.abs(clientHeight);
  };

  const getHContent = () => {
    if (fullHeight) return 'h-full';
    else if (fullSidebar) return 'h-content-no-banner';
    else return 'h-content';
  };

  $: if (loadMore) {
    page = page + 1;
    appendImages();
  }

  const buttonClass =
    'flex items-center justify-center cursor-pointer transition-all duration-150 py-2 px-4 rounded border-2';
</script>

<div class="flex h-full flex-col bg-white">
  <div class="mx-6 flex flex-row">
    <p class="grow text-base font-bold text-black">Take a Snapshot</p>
  </div>
  <!-- <div class="flex-grow" on:scroll={checkScrollEvent}> -->
  <div class="grid w-full gap-2 px-6 py-4">
    <!-- <span class="font-bold text-sm text-zinc-800">Insert new snapshot</span> -->
    <button
      on:click={() => {
        viddialogStore.set(true);
      }}
      class="rounded-lg border border-zinc-200 bg-primary px-4 py-3 text-sm font-bold text-white hover:bg-primary-500"
    >
      Take a New Snapshot
    </button>
  </div>
  <div
    class="relative grid h-full grid-cols-2 gap-5 overflow-auto px-6 py-6 {getHContent()}"
    on:scroll={checkScrollEvent}
  >
    {#each gridProps.images as item, i (i)}
      <div class="">
        <div class="relative aspect-auto w-full" data-template-id={item.id}>
          <button class="w-full" on:click={() => insertSnapshot(item)}>
            <img
              class="aspect-auto w-full rounded-lg border border-slate-800 bg-gray-800 shadow-md"
              src={item.src}
              alt={item.title}
            />
          </button>
        </div>
      </div>
    {/each}
  </div>
  <!-- </div> -->
</div>

<style lang="postcss">
  .h-content-no-banner {
    height: calc(100vh - 60px);
    height: calc(100svh - 60px);
  }
  .h-content {
    height: calc(100vh - 250px);
    height: calc(100svh - 250px);
  }
  ::-webkit-scrollbar {
    @apply w-2 rounded-full bg-slate-100 p-1;
  }
  ::-webkit-scrollbar-track {
    @apply rounded-full shadow-gray-500;
  }
  ::-webkit-scrollbar-thumb {
    @apply rounded-full bg-gray-400;
  }
  ::-webkit-scrollbar-thumb:hover {
    @apply rounded-full bg-gray-500;
  }
  details > summary {
    list-style-type: none;
    outline: none;
    cursor: pointer;
  }

  details > summary::-webkit-details-marker {
    display: none;
  }

  details > summary::before {
    content: '';
  }

  details[open] > summary::before {
    content: '';
  }
</style>
